import { createFileRoute } from '@tanstack/react-router'
import { DonatePage } from '@/features/donate/templates'

export const Route = createFileRoute('/donate/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <DonatePage dreamId={id} />
}
